import type { ReactNode } from "react";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { Check, DarkMode, LightMode, SettingsBrightness } from "@mui/icons-material";
import { useThemeModeToggleViewModel, type ThemeModeValue } from "./ThemeModeToggle.vm";

const MODE_ICON: Record<ThemeModeValue, ReactNode> = {
	light: <LightMode fontSize="small" />,
	dark: <DarkMode fontSize="small" />,
	system: <SettingsBrightness fontSize="small" />,
};

/**
 * Light / Dark / System theme picker, rendered as three radio-style `MenuItem`s so it slots
 * into the account menu's `MenuList` (native roving-tabindex keyboard nav) — a `ToggleButtonGroup`
 * inside a `Menu` is an a11y anti-pattern. Selecting a mode does NOT close the menu, so the user
 * can compare modes. A `<>`-fragment keeps each `<li>` a direct DOM child of the menu `<ul>`.
 */
export function ThemeModeToggle() {
	const vm = useThemeModeToggleViewModel();
	return (
		<>
			{vm.options.map((option) => {
				const isActive = option.value === vm.activeMode;
				return (
					<MenuItem key={option.value} selected={isActive} onClick={() => vm.setMode(option.value)}>
						<ListItemIcon>{MODE_ICON[option.value]}</ListItemIcon>
						<ListItemText>{option.label}</ListItemText>
						{isActive && <Check fontSize="small" sx={{ ml: 2, color: "text.secondary" }} />}
					</MenuItem>
				);
			})}
		</>
	);
}
